/**
 * Owner: Masa Bayu
 * File: script-hints.ts
 * Date:Time: 2026-09-20 00:59
 * Description: language ↔ default script hints — Batch 7 regional primaries.
 */
import { QxLanguageError } from './errors';
/** ISO 15924–aligned script codes (Title case). */
const SCRIPT_PATTERN = /^[A-Z][a-z]{3}$/;
/** Default script by primary language when tag has no script subtag. */
export const QX_DEFAULT_SCRIPT_BY_PRIMARY = Object.freeze({
    en: 'Latn',
    ms: 'Latn',
    id: 'Latn',
    fr: 'Latn',
    de: 'Latn',
    es: 'Latn',
    pt: 'Latn',
    ar: 'Arab',
    fa: 'Arab',
    ur: 'Arab',
    he: 'Hebr',
    yi: 'Hebr',
    ru: 'Cyrl',
    uk: 'Cyrl',
    bg: 'Cyrl',
    sr: 'Cyrl',
    mk: 'Cyrl',
    be: 'Cyrl',
    el: 'Grek',
    th: 'Thai',
    lo: 'Laoo',
    km: 'Khmr',
    my: 'Mymr',
    hi: 'Deva',
    mr: 'Deva',
    ne: 'Deva',
    sa: 'Deva',
    bn: 'Beng',
    as: 'Beng',
    pa: 'Guru',
    gu: 'Gujr',
    or: 'Orya',
    ta: 'Taml',
    te: 'Telu',
    kn: 'Knda',
    ml: 'Mlym',
    si: 'Sinh',
    pl: 'Latn',
    cs: 'Latn',
    sk: 'Latn',
    hu: 'Latn',
    ro: 'Latn',
    tr: 'Latn',
    vi: 'Latn',
    fi: 'Latn',
    et: 'Latn',
    lv: 'Latn',
    ja: 'Jpan',
    ko: 'Kore',
    zh: 'Hans',
    hy: 'Armn',
    ka: 'Geor',
    am: 'Ethi',
    ti: 'Ethi',
    bo: 'Tibt',
});
export function assertScriptId(scriptId) {
    const trimmed = scriptId.trim();
    if (!SCRIPT_PATTERN.test(trimmed)) {
        throw new QxLanguageError('INVALID_SCRIPT_ID', `scriptId must be ISO 15924–like Title case (e.g. Latn, Arab): ${scriptId}`);
    }
    return trimmed;
}
/**
 * Resolve script for a parsed languageId.
 * Prefer explicit script subtag; else default-by-primary hint; else null (unknown).
 */
export function resolveScriptHint(parsed) {
    if (parsed.script) {
        return assertScriptId(parsed.script);
    }
    const fallback = QX_DEFAULT_SCRIPT_BY_PRIMARY[parsed.primary];
    return fallback ?? null;
}
//# sourceMappingURL=script-hints.js.map